import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-spirit",
  "use": "icon-spirit-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-spirit\"><path d=\"M962.3 0v509.5s-56.6 141.5-283 84.9c0 0-265.6-79.7-385.1 43.9l143.6 375.6-26.4 10.1-368-962.3 26.4-10.1 53 138.8c46.4-36 254.4-180.2 528.2-105.5 0 0 198.1 56.6 311.3-84.9z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol